module.exports = __webpack_public_path__ + "static/img/hainan-women-children-medical-center.d53de5d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/partners/hainan-women-children-medical-center.png
// module id = dTuf
// module chunks = 1 2